import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  paper: {
    marginTop: 24,
    marginBottom: 24,
  },
};

export default styles;
